import React, { useState, useEffect, useRef } from 'react';

import { Modal } from 'flowbite';

import ExpenseFundApprovalsTableRow from './ExpenseFundApprovalsTableRow';
import ExpenseFundApprovalViewModal from './ExpenseFundApprovalViewModal';

import { modalOptions } from 'Helpers/modalOptions';

import PaginationInfo from 'CommonComponents/PaginationInfo';
import TablePagination from 'CommonComponents/TablePagination';

function ExpenseFundApprovalsTable(props) {
    const [expenseFundApprovals, setExpenseFundApprovals] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [to, setTo] = useState(1);
    const [from, setFrom] = useState(1);
    const [total, setTotal] = useState(1);
    const [viewedEFA, setViewedEFA] = useState({});

    const [expenseFundApprovalViewModalElement, setExpenseFundApprovalViewModalElement] = useState(null);

    const expenseFundApprovalViewModalRef = useRef();

    useEffect(() => {
        if (Object.keys(viewedEFA).length > 0) {
            expenseFundApprovalViewModalElement && expenseFundApprovalViewModalElement.show();
        }
    }, [viewedEFA]);

    useEffect(() => {
        fetchExpenseFundApprovals();
        expenseFundApprovalViewModalRef && setExpenseFundApprovalViewModalElement(new Modal(expenseFundApprovalViewModalRef.current, modalOptions(false)));
    }, []);

    const viewEFA = (efa) => {
        setViewedEFA({ ...efa });
    };

    const defaultUrl = props.fetchExpenseFundApprovalsUrl + '?per_page=' + perPage;

    const combineFetchUrl = (p = null, pp = null) => {
        return props.fetchExpenseFundApprovalsUrl + '?per_page=' + (pp || perPage) + '&page=' + (p || page);
    };

    const fetchExpenseFundApprovals = (url = null) => {
        const fetchUrl = url || defaultUrl;

        axios
            .get(fetchUrl)
            .then((res) => {
                const { data, to, from, total, last_page } = res.data;
                setExpenseFundApprovals(data);
                setTo(to);
                setFrom(from);
                setTotal(total);
                setLastPage(last_page);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    function pageChange(data) {
        const url = combineFetchUrl(data.selected + 1);
        setPage(+data.selected + 1);
        fetchExpenseFundApprovals(url);
    }

    const resetData = () => {
        setViewedEFA({});
        expenseFundApprovalViewModalElement && expenseFundApprovalViewModalElement.hide();
    };

    return (
        <div>
            <div className="table__pagination-info tw-mb-6">
                <PaginationInfo to={to} from={from} total={total} />
                <TablePagination lastPage={lastPage} pageChange={pageChange} />
            </div>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th className="tw-w-2/5">{$t('Expense')}</th>
                            <th>{$t('Status')}</th>
                            <th>{$t('Amount Requested')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {expenseFundApprovals.map((expenseFundApproval) => {
                            return (
                                <ExpenseFundApprovalsTableRow
                                    key={expenseFundApproval.id}
                                    expenseFundApproval={expenseFundApproval}
                                    clickHandler={() => viewEFA(expenseFundApproval)}
                                />
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <ExpenseFundApprovalViewModal
                modalId={'view-efa'}
                modalRef={expenseFundApprovalViewModalRef}
                modalElement={expenseFundApprovalViewModalElement}
                closeHandler={resetData}
                successHandler={resetData}
                efa={viewedEFA}
                displayApprovalStatuses={props.displayApprovalStatuses}
            />
        </div>
    );
}

export default ExpenseFundApprovalsTable;
